jQuery(document).ready(function($){
	//MANIPULANDO CORE
	LP.reload = function (url) {
		if (!url) {
			url = window.location.href;
		}
		//A la hora de comprar redirecciona a si mismo entonces haremos que redireccione al intro
		if(url == LP.getUrl() ){
			url = LP.getUrl() + '/lessons/introduccion/';
		} 
		window.location.href = url;
	};
	//LANG
	window.learn_press_js_localize.confirm_cancel_order = {
		message : '¿Estás seguro que quieres salir del curso?',
		title : 'Cancelar orden'
	}

	window.learn_press_js_localize.invalid_field = 'Hay un error en el formulario. Por favor, revisa haber llenado correctamente todos los campos';
	window.learn_press_js_localize.unknown_error = 'Error desconocido!';
	if(typeof window.learn_press_single_course_localize != 'undefined'){
		window.learn_press_single_course_localize.confirm_finish_course = {
			message: window.learn_press_single_course_localize.confirm_finish_course.message.replace('Are you sure you want to finish course ', '¿Estás seguro que quieres terminar el curso de: ') ,
			title:'Terminar curso'
		};
		window.learn_press_single_course_localize.confirm_finish_quiz = {
			message: '¿Estas seguro que quieres terminar el examen?',
			title:'Terminar examen'
		};
		window.learn_press_single_course_localize.confirm_retake_course = {
			message: window.learn_press_single_course_localize.confirm_retake_course.message.replace('Are you sure you want to retake course ', '¿Estás seguro que quieres retomar el curos de: ') + '?',
			title:'Retomar curso'
		};
		window.learn_press_single_course_localize.confirm_retake_quiz = {
			message:window.learn_press_single_course_localize.confirm_retake_course.message.replace('Are you sure you want to retake quiz  ', '¿Estas seguro que quieres retomar el examen de: '),
			title:'Retomar examen'
		};
		window.learn_press_single_course_localize.quiz_time_is_over = {
			message: '¡El tiempo se acabo!The time is over! Necesitas volver a comenzar tu examen',
			title:'Tiempo!'
		};
		window.learn_press_single_course_localize.retaken_quiz = '¡Felicidades! Retomaste este examen. Por favor espera un momento para que la página recargue';
	}
	//FB API
	window.fbAsyncInit = function() {
	    FB.init({
	      appId      : '504593576401546',
	      xfbml      : true,
	      version    : 'v2.7'
	    });
	};

	(function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

	if($('.sidemenu').length > 0){
		var sidemenutop = $('.sidemenu').offset().top;
		var setFixedSideMenu = function(){
			if((sidemenutop - 120) < $(window).scrollTop()){
		  		$('.sidemenu').addClass('fixed');
		  		$('.homeContent').addClass('fixed-margin');
		  	}else{
		  		$('.sidemenu').removeClass('fixed');
		  		$('.homeContent').removeClass('fixed-margin');
		  	}
		}
		setFixedSideMenu();
		$( window ).scroll(function() {
		  	setFixedSideMenu();
		});
	}
	$('.itrtab nav ul li a').on('click',function(e){
		e.preventDefault();
		$('.itrtab nav ul li a').removeClass('active');
		$('.itrcontent_tab').removeClass('active');
		$(this).addClass('active');
		$('#' + $(this).data('content')).addClass('active');
	});

	$('.twitterShare').on('click', function(event){
		event.preventDefault();
		var width  = 575,
	        height = 400,
	        left   = ($(window).width()  - width)  / 2,
	        top    = ($(window).height() - height) / 2,
	        url    = 'https://twitter.com/intent/tweet?related=ITR&url='+ window.location.href + '&text='+ $('h2').first().html(),
	        opts   = 'status=1' +
	                 ',width='  + width  +
	                 ',height=' + height +
	                 ',top='    + top    +
	                 ',left='   + left;
	    
	    window.open(url, 'twitter', opts);
	 
	    return false;
	});

	$('.fbShare').on('click', function(event){
		event.preventDefault();
		FB.ui({
		  method: 'share',
		  href: window.location.href,
		}, function(response){});
	});
	//DETAIL COURSE
	$('.lp-icon.item-status').click(function(){
		$(this).closest('li').trigger('click');
	});
	var max_width_break = 1140;
	$( window ).resize(function() {
		if($('#popup-sidebar').length > 0){
			var window_with = $( window ).width();
			if(window_with > max_width_break){
				var dif = window_with - max_width_break;
				dif = Math.floor(dif/2);
				$('#course-curriculum-popup #popup-sidebar').css({
					left: dif +'px'
				});
				$('#course-curriculum-popup #popup-main #popup-header').css({
					'margin-left': '-' + dif + 'px'
				});
				$("#course-curriculum-popup #popup-main").css("cssText", "left: " + ( dif + 300 ) + 'px' +" !important;");
			}
		}
	});
	
	setTimeout(function(){
		if($('#popup-sidebar').length > 0){
			var window_with = $( window ).width();
			if(window_with > max_width_break){
				var dif = window_with - max_width_break;
				dif = Math.floor(dif/2);
				$('#course-curriculum-popup #popup-sidebar').css({
					left: dif +'px'
				});
				$('#course-curriculum-popup #popup-main #popup-header').css({
					'margin-left': '-' + dif + 'px'
				});
				$("#course-curriculum-popup #popup-main").css("cssText", "left: " + ( dif + 300 ) + 'px' +" !important;");
			}
			/*$('#popup-content-inner iframe').on('load',function(){
		        $('#titulo_afuera').html($('.course-lesson-description h2',$('#popup-content-inner iframe').contents()).text());
		    });*/
		}
	},1500);
	
	//LESSONS
	if($('.learn-press-form').length > 0){
		$('.nav-next').click(function(e){
			$('.learn-press-form').trigger('submit');
			var $this = $(this);
			setTimeout(function(){
				$this.find('.button-load-item').trigger('click');
				$this.addClass('hide-after');
			},100);
		});
	}else{
		$('.nav-next').addClass('hide-after');
	}

	// LOGIN
	if($('#learn-press-form-login').length > 0){
		$('#learn-press-form-login').on('submit',function(e){
			e.preventDefault();
			var bfallo = false;
			//Validando el user
			var user = $('#user_login').val();
			if(user == ''){
				bfallo = true;
				addMsgError($('#user_login'),'El correo electrónico no puede ir vacío');
			}else if(!isEmail(user)){
				bfallo = true;
				addMsgError($('#user_login'),'El correo electrónico tiene que tener un formato de correo valido');
			}else{
				removeMsgError($('#user_login'));
			}
			//Validando el user
			var pass = $('#user_pass').val();
			if(pass == ''){
				bfallo = true;
				addMsgError($('#user_pass'),'La contraseña no puede ir vacía');
			}else{
				removeMsgError($('#user_pass'));
			}
			if(!bfallo){
				$('#learn-press-form-login').off('submit').trigger('submit');
			}
		});
	}

	$('#contactForm').submit(function(event){
		event.preventDefault();
		var nombre = $('#contactNombre').val();
		var correo = $('#contactCorreo').val();
		var consulta = $('#contactConsulta').val();
		/*$('#contactNombre').val('');
		$('#contactCorreo').val('');
		$('#contactConsulta').val('');*/
		if(nombre != '' && correo != '' && consulta != '' ){
			$.ajax({
		        url: my_ajax_object.ajax_url,
		        data: {
		            'action':'contact_ajax_request',
		            'nombre' : nombre,
		            'correo' : correo,
		            'consulta' : consulta 
		        },
		        success:function(data) {
		        	$.alerts._show('Solicitud enviada','Pronto nos pondremos en contacto contigo',null,'alert',function(){
		        	});
		        },
		        error: function(errorThrown){
		            console.log(errorThrown);
		        }
		    });
		}
	});

	//Quiz
	if($('.button-start-quiz').length > 0){
		$('.nav-next.nav-link').remove();
	}
	if($('.button-finish-quiz').length > 0){
		$('.button-finish-quiz').on('click',function(){
			$('.button-finish-quiz').trigger('click');
		});
	}
	if($('.button-retake-quiz').length > 0){
		$('.nav-next.nav-link').hide();
	}
	setTimeout(function(){
		if(typeof $LP_Quiz != 'undefined'){
			$LP_Quiz.model.on("change", function() {
				if(!$LP_Quiz.model.isLast()){
					$('.button-finish-quiz').addClass('hide-if-js');
					window.top.jQuery('.block-popup-sidebar').show();
					window.top.jQuery('.block-popup-header').show();
				}else{
					window.top.jQuery('.block-popup-sidebar').hide();
					window.top.jQuery('.block-popup-header').hide();
				}
			});
			if($LP_Quiz.model.get('status') != 'completed' && $LP_Quiz.model.get('status') != 'viewed'){
				$('#lp-navigation').hide();
			}
			if($('.certificate').length > 0){
				$('.certificate').click(function(e){
					e.preventDefault();
					window.top.location.href = '/certificate';
				});
				$('.nav-next.nav-link.hide-after').remove();
			}
			//vamos a eliminar el terminar quiz cuando estemos en una quiz
			$('#learn-press-finish-course').remove();
			//vamos a ver si ya pueden dar siguiente:
			$('.answer-option').live('click',function(){
				$('.block-button-next-question').remove();
			})
		}
	});

	//Solicitando un diploma

	$('.solicita_diploma').on('click', function(event){
		event.preventDefault();
		$.ajax({
	        url: my_ajax_object.ajax_url,
	        data: {
	            'action':'example_ajax_request',
	            'leccion' : $(this).data('leccion')
	        },
	        success:function(data) {
	        	$.alerts._show('Solicitud enviada','Tu diploma ya fue solitado',null,'alert',function(){
	        		$('.nav-next').trigger('click');
	        	});
	        },
	        error: function(errorThrown){
	            console.log(errorThrown);
	        }
	    });
	});

	// Solicita certificado
	$('.solicita_certificado').on('click', function(event){
		event.preventDefault();
		$.ajax({
	        url: my_ajax_object.ajax_url,
	        data: {
	            'action':'certificado_ajax_request'
	            //Tal vez despues se tenga que hacer para otros despues 
	        },
	        success:function(data) {
	        	$.alerts._show('Solicitud enviada','Tu certificado ya fue solitado',null,'alert',function(){
	        		$('.nav-next').trigger('click');
	        	});
	        },
	        error: function(errorThrown){
	            console.log(errorThrown);
	        }
	    });
	});
});

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function addMsgError($elem, msg){
	if($elem.closest('p').find('small').length == 0){
		$elem
		.closest('p')
		.addClass('warning')
		.find('label')
		.after('<span><small>' + msg + '</small></span>');
	}else{
		$elem.closest('p').find('small').html(msg);
	}
}

function removeMsgError($elem){
	$elem.closest('p').removeClass('warning').find('span').remove();
}